import BusinessHero from '@/components/business/BusinessHero';
import TaxExemptAccount from '@/components/business/tax-exempt/TaxExemptAccount';
import TaxExemptSteps from '@/components/business/tax-exempt/Steps';
import { BUSINESS_EMAIL } from '@/components/business/tax-exempt/constants';
import { WebsiteSchema } from '@/components/homepage/WebsiteSchema';
import { REDIRECT_HOME } from '@/lib/common';
import settings from '@/settings';
import i18n from '@/settings/i18n';

const t = i18n.init('business');

/** US sales tax only; reebelo-dev for local work. */
const TAX_EXEMPT_STORES = ['reebelo-us', 'reebelo-dev'];

export const getServerSideProps = () => {
  if (!TAX_EXEMPT_STORES.includes(settings.store)) {
    return REDIRECT_HOME;
  }

  return { props: {} };
};

const TaxExemptPage = () => (
  <div className="bg-white">
    <WebsiteSchema
      title={t`Buy Sales Tax-Free for Your Business | Reebelo for Business`}
      description={t`Qualifying businesses can submit their exemption certificate and shop tax-free on Reebelo.`}
    />
    <BusinessHero
      badge={t`For qualifying businesses & organizations`}
      title={t`Buy sales tax-free for your business.`}
      description={t`Qualifying businesses can submit their exemption certificate and shop tax-free on Reebelo.`}
    />
    <TaxExemptSteps />
    <div className="bg-gray-300 py-10 md:py-12">
      <div className="reebelo-container">
        <TaxExemptAccount />
        <div className="max-w-xl mx-auto mt-8 text-center text-xs text-gray-700/60">
          <p>
            {t`We'll review your application within 3 business days and email you if we need more information.`}{' '}
            {t`Once you're approved, you can make tax-exempt purchases immediately.`}
          </p>
          <p className="mt-4">
            {t`Need help? Contact`}{' '}
            <a
              href={`mailto:${BUSINESS_EMAIL}`}
              className="font-medium text-gray-700 underline"
            >
              {BUSINESS_EMAIL}
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default TaxExemptPage;
